var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import require$$0, { createContext, useContext, useState, useMemo, useEffect, useCallback } from "react";
import { Box, Loading } from "@ktag/styleguide/dist/react";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  g !== void 0 && (e = "" + g);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const fallback = [
  void 0,
  (user) => {
    fallback[0] = user;
  },
  true
];
const AuthenticatedUserContext = createContext(fallback);
function useAuthenticatedModifyContext() {
  const [user, setUser] = useContext(AuthenticatedUserContext);
  return [user, setUser];
}
function useAuthenticatedContext() {
  const [user, _, isFallback] = useContext(AuthenticatedUserContext);
  if (isFallback) {
    throw new Error("In order to use useAuthenticationContext, you need to provider a AuthenticatedUserStore somewhere above (possibly the root).");
  }
  return user;
}
function AuthenticatedUserStore(props) {
  const { children } = props;
  const [user, setUser] = useState();
  return jsxRuntime.exports.jsx(AuthenticatedUserContext.Provider, { value: [user, setUser, false], children });
}
class AuthenticationError extends Error {
}
class AcrValuesNotFulfilledError extends AuthenticationError {
}
class ContextTypesNotFulfilledError extends AuthenticationError {
}
class NotLoggedInError extends AuthenticationError {
}
class RoleRequirementNotFulfilledError extends AuthenticationError {
}
class FilterRequirementNotFulfilledError extends AuthenticationError {
  constructor(error) {
    super();
    Object.defineProperty(this, "error", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.error = error;
  }
}
function includesEvery(sources, required) {
  if (required && required.length) {
    return required.every((r) => sources.indexOf(r) > -1);
  }
  return true;
}
function includesSome(sources, required) {
  if (required && required.length) {
    return required.some((r) => sources.indexOf(r) > -1);
  }
  return true;
}
function createUrlWithParams(url, params = {}) {
  const urlParams = new URLSearchParams();
  Object.keys(params).filter((key) => params[key]).forEach((key) => urlParams.set(key, params[key]));
  return `${url}?${urlParams.toString()}`;
}
function redirectWithParams(url, params = {}) {
  const href = createUrlWithParams(url, params);
  console.log({ href });
  window.location.href = href;
}
function performLoginRequest(urls, acrValues, allowedContextTypes) {
  performAcrValueSwitchRequest(urls, acrValues, allowedContextTypes);
}
function performAcrValueSwitchRequest(urls, acrValues, allowedContextTypes) {
  let target = window.location.href;
  if (allowedContextTypes) {
    target = createUrlWithParams(urls.contextSwitchUrl, {
      contextTypes: allowedContextTypes ? allowedContextTypes.join(",") : "",
      target: window.location.href,
      back: window.location.href
    });
  }
  redirectWithParams(urls.loginUrl, {
    acr_values: acrValues ? acrValues.join(" ") : "",
    target
  });
}
function performContextSwitchRequest(urls, allowedContextTypes) {
  redirectWithParams(urls.contextSwitchUrl, {
    contextTypes: allowedContextTypes ? allowedContextTypes.join(",") : "",
    target: window.location.href,
    back: window.location.href
  });
}
function getDocumentPropertyOrDefault(name, defaultValue) {
  if (Object.prototype.hasOwnProperty.call(document.documentElement.dataset, name)) {
    const value = document.documentElement.dataset[name];
    if (value && value.length) {
      return value;
    }
  }
  return defaultValue;
}
function AuthorizationErrorBox(props) {
  const { message } = props;
  return jsxRuntime.exports.jsx(Box, { type: "negative", icon: "attention", heading: "Fehlende Berechtigungen", children: jsxRuntime.exports.jsx("p", { children: message }) });
}
function DefaultLoader() {
  return jsxRuntime.exports.jsx(Loading, {});
}
async function fetchUser(url) {
  return fetch(url, { cache: "no-cache", credentials: "include" }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res;
  }).then((res) => res.json());
}
function showErrorBox(message) {
  return jsxRuntime.exports.jsx(AuthorizationErrorBox, { message });
}
function AuthenticatedUserRequired(props) {
  const { performLogin, allowedContextTypes, performContextSwitch, allRequiredRoles, anyRequiredRoles, anyRequiredAcrValue, performAcrValueSwitch, filter, children, loader, errorHandler } = props;
  const urlConfiguration = useMemo(() => ({
    loginUrl: getDocumentPropertyOrDefault("loginApi", "/api/v1/token/login"),
    profileUrl: getDocumentPropertyOrDefault("profileApi", "/api/v1/profiles/me"),
    contextSwitchUrl: getDocumentPropertyOrDefault("contextSwitchApi", "/de/smartserviceportal/konto/kontext-wechsel")
  }), []);
  const [user, setUser] = useAuthenticatedModifyContext();
  const [{ isAllowed, error }, setState] = useState({
    isAllowed: void 0,
    error: void 0
  });
  const updateState = (update) => {
    setState((current) => {
      return __spreadValues(__spreadValues({}, current), update);
    });
  };
  useEffect(() => {
    const processAuthentication = async () => {
      try {
        let fetchedUser;
        if (!user) {
          const userResponse = await fetchUser(urlConfiguration.profileUrl);
          setUser(userResponse);
          fetchedUser = userResponse;
        } else {
          fetchedUser = user;
        }
        updateState({ error: void 0 });
        if (!fetchedUser.acr || !includesSome(fetchedUser.acr, anyRequiredAcrValue)) {
          if (performAcrValueSwitch) {
            return performAcrValueSwitchRequest(urlConfiguration, anyRequiredAcrValue, allowedContextTypes);
          }
          return updateState({
            isAllowed: false,
            error: new AcrValuesNotFulfilledError()
          });
        }
        if (!fetchedUser.context || !includesSome([fetchedUser.context.type], allowedContextTypes)) {
          if (performContextSwitch) {
            return performContextSwitchRequest(urlConfiguration, allowedContextTypes);
          }
          return updateState({
            isAllowed: false,
            error: new ContextTypesNotFulfilledError()
          });
        }
        if (!fetchedUser.roles || !includesEvery(fetchedUser.roles, allRequiredRoles)) {
          return updateState({
            isAllowed: false,
            error: new RoleRequirementNotFulfilledError()
          });
        }
        if (!fetchedUser.roles || !includesSome(fetchedUser.roles, anyRequiredRoles)) {
          return updateState({
            isAllowed: false,
            error: new RoleRequirementNotFulfilledError()
          });
        }
        if (filter) {
          try {
            const filterResult = await filter(fetchedUser);
            if (!filterResult) {
              return updateState({
                isAllowed: false,
                error: new FilterRequirementNotFulfilledError()
              });
            }
          } catch (filterError) {
            if (typeof filterError === "string" || filterError instanceof Error) {
              return updateState({
                isAllowed: false,
                error: new FilterRequirementNotFulfilledError(filterError)
              });
            } else {
              return updateState({
                isAllowed: false,
                error: new FilterRequirementNotFulfilledError()
              });
            }
          }
        }
        return updateState({ isAllowed: true });
      } catch (e) {
        if (performLogin) {
          return performLoginRequest(urlConfiguration, anyRequiredAcrValue, allowedContextTypes);
        }
        return updateState({ isAllowed: false, error: new NotLoggedInError() });
      }
    };
    processAuthentication();
  }, [
    performLogin,
    allowedContextTypes,
    performContextSwitch,
    allRequiredRoles,
    anyRequiredRoles,
    filter
  ]);
  if (isAllowed === void 0) {
    return loader;
  }
  if (!isAllowed) {
    if (error) {
      if (errorHandler) {
        return errorHandler(error);
      }
      switch (error.constructor) {
        case NotLoggedInError:
          return showErrorBox("Sie m\xFCssen sich einloggen um auf diese Seite zuzugreifen.");
        case AcrValuesNotFulfilledError:
          return showErrorBox("Sie m\xFCssen sich mit einem st\xE4rkeren Authentisierungsverfahren anmelden.");
        case ContextTypesNotFulfilledError:
          return showErrorBox("Sie verf\xFCgen nicht \xFCber den ben\xF6tigten Benutzertyp.");
        case RoleRequirementNotFulfilledError:
        case FilterRequirementNotFulfilledError:
        default:
          return showErrorBox("Sie verf\xFCgen nicht \xFCber die ben\xF6tigten Berechtigungen.");
      }
    }
    return showErrorBox("Sie verf\xFCgen nicht \xFCber die ben\xF6tigten Berechtigungen.");
  }
  return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children });
}
AuthenticatedUserRequired.defaultProps = {
  performLogin: false,
  allowedContextTypes: null,
  performContextSwitch: false,
  allRequiredRoles: null,
  anyRequiredRoles: null,
  anyRequiredAcrValue: null,
  performAcrValueSwitch: false,
  loader: jsxRuntime.exports.jsx(DefaultLoader, {}),
  errorHandler: null
};
var ContextType;
(function(ContextType2) {
  ContextType2["PrivateSelf"] = "PrivateSelf";
  ContextType2["OrgSelfregister"] = "OrgSelfregister";
  ContextType2["OrgUID"] = "OrgUID";
  ContextType2["OrgGemeinde"] = "OrgGemeinde";
  ContextType2["OrgKanton"] = "OrgKanton";
  ContextType2["OrgKantonExtern"] = "OrgKantonExtern";
  ContextType2["OrgSSI"] = "OrgSSI";
  ContextType2["System"] = "System";
})(ContextType || (ContextType = {}));
var ContextType$1 = ContextType;
var KnownAcrValues;
(function(KnownAcrValues2) {
  KnownAcrValues2["pwd"] = "urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport";
  KnownAcrValues2["sso2fa"] = "urn:oasis:names:tc:SAML:2.0:ac:classes:MobileTwoFactorUnregistered";
  KnownAcrValues2["eidasLow"] = "http://eidas.europa.eu/LoA/low";
  KnownAcrValues2["eidasSubstantial"] = "http://eidas.europa.eu/LoA/substantial";
  KnownAcrValues2["eidasHigh"] = "http://eidas.europa.eu/LoA/high";
})(KnownAcrValues || (KnownAcrValues = {}));
var KnownAcrValues$1 = KnownAcrValues;
var PromiseStatus;
(function(PromiseStatus2) {
  PromiseStatus2[PromiseStatus2["NOT_STARTED"] = 0] = "NOT_STARTED";
  PromiseStatus2[PromiseStatus2["PENDING"] = 1] = "PENDING";
  PromiseStatus2[PromiseStatus2["SUCCESS"] = 2] = "SUCCESS";
  PromiseStatus2[PromiseStatus2["ERROR"] = 3] = "ERROR";
})(PromiseStatus || (PromiseStatus = {}));
class SuspendableState {
  constructor(promiseFactory, previousValue, stateUpdater) {
    Object.defineProperty(this, "status", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: PromiseStatus.NOT_STARTED
    });
    Object.defineProperty(this, "suspender", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "result", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "previousValue", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "promiseFactory", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "stateUpdater", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.promiseFactory = promiseFactory;
    this.previousValue = previousValue;
    this.stateUpdater = stateUpdater;
  }
  read(stale = false) {
    this.startIfNotStarted();
    if (this.status === PromiseStatus.NOT_STARTED || this.status === PromiseStatus.PENDING) {
      if (stale && this.previousValue) {
        return [this.previousValue, { loading: true, stale: true }];
      }
      throw this.suspender;
    } else if (this.status === PromiseStatus.ERROR) {
      throw this.result;
    } else if (this.status === PromiseStatus.SUCCESS) {
      return [this.result, { loading: false, stale: false }];
    }
    throw new Error("invalid state");
  }
  startIfNotStarted() {
    if (this.status === PromiseStatus.NOT_STARTED) {
      this.suspender = this.promiseFactory().then((r) => {
        this.status = PromiseStatus.SUCCESS;
        this.result = r;
        if (this.stateUpdater) {
          this.stateUpdater();
        }
      }, (e) => {
        this.status = PromiseStatus.ERROR;
        this.result = e;
      });
    }
  }
  getResult() {
    return this.result;
  }
  getStatus() {
    return this.status;
  }
}
function promiseToSuspend(promiseFactory, previousValue, stateUpdater) {
  return new SuspendableState(promiseFactory, previousValue, stateUpdater);
}
function create(key, promiseFactory, options, deps, previousValue, stateUpdater) {
  return {
    suspend: promiseToSuspend(() => promiseFactory(key, deps), previousValue, stateUpdater),
    abortFn: options.abortFn,
    deps,
    previousValue
  };
}
function abortIfDefined(fn) {
  if (fn) {
    try {
      fn();
    } catch (e) {
      if (e instanceof Error && e.message === "Illegal invocation") {
        console.error("you passed a native function to abortFn which is not allowed. Please use the form: () => yourNativeFn()");
      } else {
        throw e;
      }
    }
  }
}
const suspenderRegistry = {};
function useCreateSuspender(key, promiseFactory, options, deps) {
  const [_, setStateUpdate] = useState(0);
  const triggerUpdate = useCallback(() => {
    return setStateUpdate((i) => i + 1);
  }, [setStateUpdate]);
  if (suspenderRegistry[key]) {
    const entry = suspenderRegistry[key];
    const depsMatch = entry.deps.length === deps.length && entry.deps.every((sd, i) => Object.is(sd, deps[i]));
    if (!depsMatch) {
      abortIfDefined(entry.abortFn);
      let previousValue = entry.previousValue;
      if (entry.suspend.getStatus() === PromiseStatus.SUCCESS) {
        previousValue = entry.suspend.getResult();
      }
      suspenderRegistry[key] = create(key, promiseFactory, options, deps, previousValue, previousValue ? triggerUpdate : void 0);
    }
  } else {
    suspenderRegistry[key] = create(key, promiseFactory, options, deps);
  }
  const { suspend } = suspenderRegistry[key];
  return {
    read: suspend.read.bind(suspend)
  };
}
export { AcrValuesNotFulfilledError, AuthenticatedUserRequired, AuthenticatedUserStore, AuthenticationError, ContextType$1 as ContextType, ContextTypesNotFulfilledError, FilterRequirementNotFulfilledError, KnownAcrValues$1 as KnownAcrValues, NotLoggedInError, RoleRequirementNotFulfilledError, useAuthenticatedContext, useCreateSuspender };
